import React, { useEffect, useState } from "react";
import { Table, Input, Tag } from "antd";
import { SearchOutlined, EyeOutlined } from "@ant-design/icons";
import { loadingPlanService } from "../../../services";
import { Link } from "react-router-dom";
import { useDebounce } from "../../../hooks/useDebounce";
import { GoDotFill } from "react-icons/go";
import { withDefaultRender } from "../../../utils/tableDefaultRender";

function SendLoadPlan() {

  const [loading, setLoading] = useState(false);
  const [plans, setPlans] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    total: 0,
    pageSize: 10,
  });
  const [search, setSearch] = useState(null)
  const debouncedSearch = useDebounce(search, 500);

  const columns = withDefaultRender(
    [
      {
        title: "S.No",
        dataIndex: "s.no",
        key: "s.no",
        render: (text, record, index) => index + 1,
      },
      {
        title: "id",
        dataIndex: "id",
        key: "id",
        //   render: (text, record, index) => index + 1,
      },
      {
        title: "Container Id",
        dataIndex: "container_id",
        key: "container_id",
      },
      {
        title: "Booking Number",
        dataIndex: "booking_no",
        key: "booking_no",
      },
      {
        title: "Container Number",
        dataIndex: "c_container_number",
        key: "c_container_number",
      },
      {
        title: "Location",
        dataIndex: "location",
        key: "location",
      },
      {
        title: "Status",
        dataIndex: "status",
        key: "status",
        render: (text, record) => (
          <Tag color={record?.is_client_approved_loadplan === 0 && record?.reject === 0 ? "yellow" :
            record?.reject === 1 ? "red" :
              "green"}>
            {record?.is_client_approved_loadplan === 0 && record?.reject === 0 ? "Pending" :
              record?.reject === 1 ? "Rejected" :
                "Approved"
            }
          </Tag>
        )
      },
      {
        title: "Actions",
        key: "Actions",
        render: (text, record, { _id }) => (
          < Link to={`/customers-portal/load-plan/views/${record.container_id}`} className="hover:text-primary" >
            < EyeOutlined style={{ fontSize: "16px" }} />
          </Link >
          //         <Space size="small">
          //         <Button type="primary" size="small"> 
          //            <SendOutlined style={{ fontSize: "16px" }} /> 
          //            </Button> 
          //   <Button type="primary" size="small"> 
          //  <DeleteOutlined style={{ fontSize: "16px" }} /> 
          //  </Button> 
          //          </Space>
        ),
      },
    ]);
  const initialize = async (page = 1, pageSize = pagination.current) => {
    setLoading(true);
    const { success, data } = await loadingPlanService.fetchCustomerLoadPlan(
      page,
      "loadplan_send",
      debouncedSearch
    );
    setLoading(false);
    if (success) {
      setPlans(data.containers.data);
      setPagination((prev) => ({
        ...prev,
        total: data.containers.total,
        current: page,
        pageSize,
      }));
    }
  };
  useEffect(() => {
    initialize(pagination.current, pagination.pageSize);
  }, [debouncedSearch]);
  return (
    <>
      <h1 className='mt-5 mb-6 text-sm font-normal uppercase flex items-center gap-2'><span><GoDotFill style={{ color: "#B83D3D" }} /></span>
        Sended Load Plans</h1>
      <div
        style={{
          padding: "8px",
          border: "1px solid #ccc",
          borderRadius: "8px",
          backgroundColor: "#FFFFFF",
        }}
      >
        <div className="flex justify-end">
          <Input
            placeholder="Search by Container no, Booking no"
            prefix={<SearchOutlined />}
            style={{ width: "29%", borderRadius: "24px", height: "40px" }}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        <Table
          columns={columns}
          scroll={{ x: "max-content" }}
          dataSource={plans}
          loading={loading}
          pagination={{
            current: pagination.current,
            total: pagination.total,
            pageSize: pagination.pageSize,
            onChange: (page) => initialize(page, pagination.pageSize),
            showSizeChanger: false,
          }}
          style={{ marginTop: "5px" }}
        />
      </div>
    </>

  );
}
export default SendLoadPlan;
